<template>
  <div class="logbo">
    <div class="container">
      <div class="histories">
        <Accordion
          class="accordion"
          v-for="(histories, index) in this.monthly()"
          :key="histories.key"
          :month="histories"
          :index="index"
        />
      </div>
      <div class="more">
        <div class="caption">※食べたものの記録は最大で3年分確認できます</div>
        <router-link to="/loginbonus" class="flex-justify-center" @click.native="() => { trapTrackEvent(1) }">
          <div class="back">「まんぷくメーター」に戻る</div>
        </router-link>
      </div>
    </div>

    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'エラー'"
        @close="() => tapErrorClose()"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '../../utils/DateFormatter.js'
import moment from 'moment'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import Accordion from './accordion'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'LoginBonus',
  components: {
    ErrorPopup,
    Accordion
  },
  data: function() {
    return {
      isError: false
    }
  },
  async created() {
    document.title = 'これまでに食べたもの & お知らせ'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchLoginBonus(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  mounted: function() {},
  beforeDestroy() {},
  computed: {
    ...mapGetters({
      histories: 'LoginBonus/histories',
      girl: 'LoginBonus/girl'
    })
  },
  watch: {},
  methods: {
    ...mapActions('LoginBonus', ['actionFetchLoginBonus']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionRequestExternalLink'
    ]),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Analytics', ['trackEvent']),
    moment,
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createLoginbonus())
          break
      }
    },
    monthly: function() {
      const months = []

      // ログイン履歴を月ごとに分ける
      if (this.histories) {
        var tmpMonth = ''
        var tmpDic = null
        for (const hist of this.histories) {
          const key = moment(hist.get_at).format('YYYY年MM月')
          if (key !== tmpMonth) {
            tmpDic = { key, histories: [] }
            months.push(tmpDic)
          }
          tmpMonth = key
          tmpDic.histories.push(hist)
        }
      }
      return months
    },
    link() {
      this.actionRequestExternalLink('https://www.joyfull.co.jp/menu/')
      return false
    },
    async fetchLoginBonus(token, accTime, userId, steps) {
      try {
        this.actionToggleLoading(true)

        await this.actionFetchLoginBonus({
          token,
          accTime,
          userId,
          isAll: true
        })
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)
    },
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
    }
  }
}
</script>

<style lang="scss" scoped>
.logbo {
  display: flex;
}
.container {
  width: 100%;
  color: #333333;

  .more {
    color: #66160E;

    padding: 10px 10px 30px;

    .caption {
      font-size: 3vw;
      color: #666666;
      margin-bottom: 30px;
    }
    a {
      text-decoration: none;
      color: #66160E;
      font-weight: bold;
    }
    .back {
      padding: 20px;
      background-color: white;
      border-radius: 5px;
      border: 2px solid;
    }
  }
}
</style>
